import ConfigDev from './config.dev';
import ConfigProd from './config.prod';

const root = process.env.NODE_ENV === 'production' ? ConfigProd : ConfigDev;

export default root;
